import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const AntisocialPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Policy Against Antisocial Forces"
        subTitleText="反社会的勢力への対応"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>
          反社会的勢力排除に向けた基本的な考え方及びその整備状況
        </AHeading>
        <Paragraph>
          当社は、社会的秩序や企業の健全な活動に悪影響を与えるあらゆる反社会的勢力とは一切関わらないという方針のもと、「TRIALの行動指針」及び「反社会的勢力対策規程」を当企業集団の役員・従業員へ周知・徹底し、反社会的勢力との関係排除に向け、当企業集団全体での企業倫理の浸透に取り組んでおります。
        </Paragraph>
        <Spacer h={{ sp: 20, pc: 30 }} />
        <Paragraph>
          社内体制としては、民事介入暴力に関わるトラブルに対してはグループ法務部長を総括責任者として対応する体制をとっております。また、各部門に取引先と反社会的勢力の排除に関する条項を盛り込んだ契約書を締結することを指示し実行しております。また、反社会的勢力からの圧力に対抗するため、警察署や企業防衛対策協議会等の外部の専門機関との連携関係も構築しております。
        </Paragraph>
      </section>
    </Layout>
  )
}

AntisocialPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir/' },
    { name: 'コーポレート・ガバナンス', path: '/ir/governance/' },
    { name: '反社会的勢力への対応', path: '' },
  ]

  return (
    <>
      <Head
        title="反社会的勢力への対応"
        description="トライアルホールディングスの反社会的勢力排除に向けた基本的な考え方及びその整備状況について掲載しています。"
        ogp={{ url: 'ir/governance/antisocial/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
